import { memo } from 'react'

import { useDocumentState } from '@/state'
import type { DocumentAnnotationBounds } from './annotationGeometry'

type KonvaAnnotationInteractionBoundsMirrorProps = {
  bounds: DocumentAnnotationBounds
  templateId: string
}

const KonvaAnnotationInteractionBoundsMirror = memo(
  ({ bounds, templateId }: KonvaAnnotationInteractionBoundsMirrorProps) => {
    const registerSelectableElementRef = useDocumentState(
      (state) => state.registerSelectableElementRef,
    )

    return (
      // Expose Konva-only annotations as invisible DOM boxes so existing
      // DOM-based multi-select can measure them in document coordinates.
      <div
        ref={(element) => {
          registerSelectableElementRef(templateId, element)
        }}
        className="pointer-events-none absolute inset-0 overflow-hidden"
      >
        <div
          data-konva-annotation-bounds-mirror
          className="pointer-events-none absolute"
          style={{
            height: bounds.height,
            left: bounds.left,
            top: bounds.top,
            width: bounds.width,
          }}
        />
      </div>
    )
  },
)

KonvaAnnotationInteractionBoundsMirror.displayName =
  'KonvaAnnotationInteractionBoundsMirror'

export default KonvaAnnotationInteractionBoundsMirror
